<template>
  <div class="goodList">
    <el-row :gutter="20" v-show="goodList.length">
      <el-col style="width: 25%" v-for="item in goodList" :key="item.spuId">
        <div class="good-item cursor-pointer" @click="goDetail(item)">
          <el-image
            v-show="item.fileUrl"
            :src="item.fileUrl"
            class="goodsImg"
            fit="contain"
          >
            <template slot="error">
              <img src="~@/assets/img/bitmap.png" class="goodsImg" />
            </template>
          </el-image>
          <img
            src="~@/assets/img/bitmap.png"
            v-show="!item.fileUrl"
            width="193px"
            height="157px"
          />
          <div class="ellipsis good-spu-title line-break">
            <Tooltip :innerContent="item.name" />
          </div>
          <div class="ellipsis good-spu-brand line-break">
            {{ $t("common.brand") }}：<Tooltip
              :innerContent="item.brandName || '-'"
            />
          </div>
          <div class="spu-code">
            {{ $t("product.supplyCommodityCode") }}：<Tooltip
              :innerContent="item.supplyCommodityCode || '-'"
            />
          </div>
          <div class="goquery">
            <img width="96px" :src="require('@/assets/img/goquiry.png')" />
          </div>
        </div>
      </el-col>
    </el-row>
    <el-pagination
      :current-page="page"
      :page-size="limit"
      :total="total"
      v-show="total"
      layout="total, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="getDataList"
    >
    </el-pagination>
  </div>
</template>
<script>
import Tooltip from '@/components/tooltipShow/index'
import GoodPrice from '@/components/good-price'
import { openOther } from '@/utils'
export default {
  components: {
    Tooltip,
    GoodPrice
  },
  data () {
    return {}
  },
  props: {
    goodList: {
      type: Array,
      default: () => {
        return []
      }
    },
    page: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 20
    }
  },
  methods: {
    pageSizeChangeHandle (val) {},
    // 跳转页
    getDataList (val) {
      this.$emit('refushDataList', val)
    },
    // 跳转详情页
    goDetail (goods) {
      openOther(`selectionInquiryDetail?spuId=${goods.spuId}&skuId=`)
    }
  }
}
</script>
<style lang="scss" scoped>
.goodList {
  .good-item {
    user-select: none;
    text-align: center;
    position: relative;
    background: #fff;
    height: 274px;
    padding: 12px;
    border-radius: 12px;
    margin-bottom: 10px;
    -webkit-box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 9px 0;
    -moz-box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 9px 0;
    box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 9px 0;

    &:hover {
      -webkit-box-shadow: rgba(0, 0, 0, 0.27) 0px 3px 9px 0;
      -moz-box-shadow: rgba(0, 0, 0, 0.27) 0px 3px 9px 0;
      box-shadow: rgba(0, 0, 0, 0.27) 0px 3px 9px 0;
    }

    .price_text {
      font-size: 20px;
    }
    /deep/ .price {
      margin-top: 10px;
      color: #e64c3a;
      font-weight: bold;
      .price-int {
        font-size: 20px;
      }
      .price-point {
        font-size: 10px;
      }
    }
    .good-spu-title {
      color: #333333;
      line-height: 17px;
      text-align: left;
      font-size: 16px;
      font-weight: bold;
      color: #1a1a1a;
    }
    .good-spu-brand {
      display: flex;
      margin-top: 8px;
      font-size: 12px;
      line-height: 16px;
      color: #646566;
      text-align: left;
      padding-right: 80px;
    }
    .spu-code {
      display: flex;
      margin-top: 8px;
      font-size: 12px;
      line-height: 16px;
      color: #646566;
      text-align: left;
    }
    img {
      object-fit: contain;
    }

    .goodsImg {
      width: 193px;
      height: 157px;
      object-fit: contain;
    }

    > .el-image,
    > img {
      margin-bottom: 24px;
    }

    .goquery {
      display: flex;
      position: absolute;
      right: 12px;
      bottom: 12px;
    }
  }
}
</style>
